import { connect } from 'react-redux'

import { RootState } from '../types'
import App from '../components/App'
import { MT4Connector } from '@bdswiss/mt4-connector'

const mt4 = MT4Connector.Instance

function mapStateToProps(rootState: RootState) {
  const { appState } = rootState
  return {
    loginInfo: mt4.account,
    locale: rootState.appConfig.locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale,
    accountLoaded: appState.accountLoaded,
    bondListState: rootState.bondListState,
    appType: appState.appType,
    assetsOpened: appState.assetsOpened,
    positionsOpened: appState.positionsOpened,
    selectedPosition: appState.selectedPosition,
    assets: mt4.assets,
    positions: mt4.positions,
    pendingOrders: mt4.pendingOrders,
    positionsInputs: rootState.positionsInputs,
    tradeOperationEnabled: rootState.tradingPane.tradeOperationEnabled,
    currency: appState.currency,
    appMode: appState.appMode,
  }
}

export default connect(mapStateToProps)(App)
